var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"e-dropdown__item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.openDialog()}}},[_vm._v(" Insert JSON Data Link... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }